var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('custom-scrollbar',[_c('div',{staticClass:"crm-info-wrapper"},[_vm._t("default"),(!_vm.isAllItemsLoaded)?_c('div',{ref:"load",staticStyle:{"height":"50px","display":"block"}}):_vm._e(),(!_vm.isAllItemsLoaded && !_vm.withoutLoader)?_c('div',{staticClass:"crm-preloader-wrapper"},[_c('preloader')],1):_vm._e()],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }